export default {
  'button.back': 'Back',
  'button.back.home': 'Back home',
  'button.search': 'Search',
  'button.reset': 'Reset',
  'button.edit': 'Edit',
  'button.delete': 'Delete',
  'button.submit': 'Submit',
  'button.close': 'Close',
  'button.view': 'View',
  'button.yes': 'Yes',
  'button.no': 'No',
  'button.update': 'Update',
  'button.add': 'Add',
  'button.create': 'Create',
  'button.cancel': 'Cancel',
  'button.lock': 'Lock',
  'button.unlock': 'Unlock',
  'button.import': 'Import',
  'button.export': 'Export',
  'button.register': 'Register',
  'button.save': 'Save',
  'button.loginWithAccessToken': 'Login with access token',
  'button.loginWithToken': 'Login with token',
  'button.login': 'Login',
  'user.button.viewProfile': 'View Profile',
  'user.button.logout': 'Logout',
  'user.button.changePassword': 'Change Password',
};
